import axios from 'axios';
import { has } from 'lodash';
import { CONSTANTS } from '../constants';
import HttpResponse, { HttpStatus } from './HttpResponse';

export default class HttpClient
{
    constructor()
    {
        this.client = null;
    }

    getClient(config = {})
    {
        if (this.client === null)
        {
            this.client = axios.create({
                baseURL: CONSTANTS.HTTP_REQUEST.ENDPOINT,
                timeout: config.timeout || CONSTANTS.HTTP_REQUEST.TIMEOUT,
                headers: CONSTANTS.HTTP_REQUEST.HEADERS,
                validateStatus()
                {
                    return true;
                },
                transformResponse: [(data) =>
                {
                    let parsedData = {};

                    try
                    {
                        parsedData = JSON.parse(data);
                    }
                    catch (ignore)
                    {
                        // TODO notify error logger
                        console.warn(ignore); // eslint-disable-line no-console
                    }

                    if (
                        has(parsedData, 'messages')
                        && has(parsedData, 'data')
                        && has(parsedData, 'responseCode')
                        && has(parsedData, 'status')
                    )
                    {
                        return formatSuccess(parsedData);
                    }

                    return formatUnknown(parsedData);
                }],
            });
        }

        return this.client;
    }

    /**
     *
     * @param method
     * @param url
     * @param data
     * @param config
     * @returns {Promise<HttpResponse>}
     */
    async request(method, url, data, config = {})
    {
        const response = new HttpResponse();
        response.status = HttpStatus.ERROR;
        response.messages.push('Whoops something went wrong. If the error continues, contact technical support.');
        response.response_code = 500;

        try
        {
            const r = await this.getClient(config).request({
                method, url, data,
            });

            response.messages = r.data.messages;
            response.response = r.data.response;
            response.response_code = r.data.response_code;
            response.status = r.data.status;
            response.httpClientResponse = r;
        }
        catch (exception)
        {
            // TODO notify error logger
            if (exception.code === 'ECONNABORTED')
            {
                response.messages.push(exception.message);
            }
            console.warn(exception); // eslint-disable-line no-console
        }

        return response;
    }
}

function formatSuccess(data)
{
    const response = new HttpResponse();
    response.messages = data.messages;
    response.response = data.data;
    response.response_code = data.responseCode;
    response.status = data.status;

    if (typeof data.response === 'string')
    {
        response.messages = data.messages;
    }

    return response;
}

function formatUnknown(data)
{
    const response = new HttpResponse();
    response.status = HttpStatus.ERROR;

    response.messages.push(data.message ?? 'Whoops something went wrong. If the error continues, contact technical support.');
    response.response = data;
    response.response_code = 500;

    return response;
}
